import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {ShiftPledgeReportSummary} from '../../../../services/api.client';
import {PaymentProcessingFormComponent} from '../PaymentProcessingFormComponent';
import {PledgeStatusType} from '../../../../services/api.client';

@Component({
    selector: 'pendingToPaid',
    templateUrl: './PendingToPaidComponent.html',
    styleUrls: ['./PendingToPaidComponent.scss'],
    standalone: false
})

export class PendingToPaidComponent implements OnInit, AfterViewInit {
    private readonly _reports$ = new BehaviorSubject<ShiftPledgeReportSummary[]>(null);
    reports$: Observable<ShiftPledgeReportSummary[]> = this._reports$.asObservable();
    reports: ShiftPledgeReportSummary[];

    @ViewChild(PaymentProcessingFormComponent)
    form: PaymentProcessingFormComponent;

    submitReport(): void {
        this.form.submitPendingToPaid()?.subscribe({next: (reports) => this._reports$.next(reports), error: () => {}});
    }

    ngOnInit(): void {
        this.reports$.subscribe(reports => this.reports = reports);
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.form.form.get('displayPledgeStatus').reset(PledgeStatusType.Pending, {disabled: true});
            this.form.form.get('shiftPledgeStatus').reset(PledgeStatusType.Paid, {disabled: true});
        });
    }

}
